import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, PrimaryButton } from '@/components/Card';
import { Chip, ChipRow } from '@/components/ChipRow';
import { api } from '@/lib/api';
import type { Trip } from '@shared/types';

export function TripsPage() {
  const [trips, setTrips] = useState<Trip[]>([]);

  useEffect(() => {
    api.trips().then((d) => setTrips(d.trips));
  }, []);

  return (
    <div className="space-y-4">
      <Card>
        <h2 className="font-display text-[30px] leading-none text-navy">Saved trips</h2>
        <p className="mt-2 text-sm text-muted">Each trip recomputes eligibility from the current wallet when you open it.</p>
        <div className="mt-4 grid grid-cols-1 gap-2">
          <Link to="/trips/new">
            <PrimaryButton>New trip</PrimaryButton>
          </Link>
          <Link
            to="/trips/import"
            className="block rounded-card border border-line px-4 py-3 text-center text-sm font-semibold"
          >
            Import from Google Calendar
          </Link>
        </div>
      </Card>
      {trips.map((trip) => (
        <Link key={trip.id} to={`/trips/${trip.id}`}>
          <Card className="mb-3">
            <ChipRow>
              <Chip tone="navy">{trip.originIata}</Chip>
              <Chip>→</Chip>
              <Chip tone="navy">{trip.destIata}</Chip>
              <Chip>{trip.airline}</Chip>
              <Chip>{trip.focus}</Chip>
              {trip.source === 'google_calendar' && <Chip tone="brass">Calendar</Chip>}
            </ChipRow>
            <p className="mt-2 font-semibold">{trip.label || `${trip.originIata} to ${trip.destIata}`}</p>
            <p className="text-[13px] text-muted">
              Arrive {trip.arriveEarlyMinutes} min early
              {trip.departAt ? ` · ${trip.departAt}` : ''}
            </p>
          </Card>
        </Link>
      ))}
    </div>
  );
}
